interface Props {
  pct: number; // 0-100
  color?: string;
  height?: number;
  className?: string;
}

/**
 * Animated horizontal bar. The fill width transitions in/out so re-rendering
 * with new data feels alive instead of snapping. Used inside damage tables
 * to visualize each row's contribution relative to the leader.
 */
export default function ProgressBar({ pct, color = "#f0b232", height = 8, className }: Props) {
  const safe = Math.max(0, Math.min(100, pct));
  return (
    <div
      className={`relative w-full overflow-hidden rounded ${className ?? ""}`}
      style={{ height, background: "rgba(255,255,255,0.05)" }}
    >
      <div
        className="absolute left-0 top-0 h-full rounded transition-all duration-700 ease-out"
        style={{
          width: `${safe}%`,
          background: `linear-gradient(90deg, ${color}, ${color}cc)`,
          boxShadow: `inset 0 0 0 1px ${color}33`,
        }}
      />
    </div>
  );
}
